import { Injectable } from "@angular/core";
import { Observable, map, mergeMap } from "rxjs";
import { VersionRepo } from "@app/core/version/domain/version.repo";

@Injectable({ providedIn: "root" })
export class ShouldAppBeUpdatedUseCase {
  constructor(private versionRepo: VersionRepo) {}

  execute(): Observable<boolean> {
    //Only for testing
    this.versionRepo.getAppVersion().pipe();

    return this.versionRepo
      .getMinimumVersion()
      .pipe(
        mergeMap((minVersion) =>
          this.versionRepo
            .getAppVersion()
            .pipe(map((appVersion) => minVersion.BUILD > appVersion.BUILD))
        )
      );
  }
}
